/**
 *  ------------------------------------
 *  Imports
 *  ------------------------------------
 */
import React from 'react'

/**
 *  ------------------------------------
 *  Context
 *  ------------------------------------
 */

const MaintenanceContext:any = React.createContext({ maintenance: false, isInsel: false, loaded: false })

/**
 *  ------------------------------------
 *  Exports
 *  ------------------------------------
 */
export const MaintenanceProvider = MaintenanceContext.Provider
export default MaintenanceContext
